import { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ForgotPassword } from "../Authentication/ForgotPassword";
import { OtpVerification } from "../Authentication/OtpVerification";
import { QRScanner } from "../Authentication/QRScanner";
import { ResetPassword } from "../Authentication/ResetPassword";
import { SignIn } from "../Authentication/SignIn";
import { SignUp } from "../Authentication/SIgnUp";
import { AddAssistant } from "../Pages/Assistant/AddAssistant";
import AddAssistantBuilder from "../Pages/Assistant/AddAssistantBuilder/AddAssistantBuilder";
import { AssitantsList } from "../Pages/Assistant/AssistantsList";
import ViewAssistants from "../Pages/Assistant/ViewAssistants";
import AssistantDocumentsList from "../Pages/AssistantDocuments/AssistantDocumentsList";
import AssistantFormSubmissionDetail from "../Pages/AssistantFormSubmissions/AssistantFormSubmissionDetail";
import CreateEditKnowledgeBase from "../Pages/AssistantKnowledgeBase/CreateEditKnowledgeBase";
import { Billing } from "../Pages/Billing/Billing";
import { BillingComponent } from "../Pages/Billing/BillingComponent";
import StartFreeTrial from "../Pages/Billing/StartFreeTrial";
import CallEmailHistoryList from "../Pages/CallEmailHistory/CallEmailHistoryList";
import { Chat } from "../Pages/Chat/Chat";
import ChatGroups from "../Pages/Chat/ChatGroups";
import { AddContact } from "../Pages/Contacts/AddContact";
import { AddGroup } from "../Pages/Contacts/AddGroup";
import { ContactGroupUsersList } from "../Pages/Contacts/ContactGroupUsersList";
import { ContactList } from "../Pages/Contacts/ContactsList";
import { EditContact } from "../Pages/Contacts/EditContact";
import { ScheduleCall } from "../Pages/Contacts/ScheduleCall";
import { ScheduleEmail } from "../Pages/Contacts/ScheduleEmail";
import { AddCustomer } from "../Pages/Customer/AddCustomer";
import { CustomerList } from "../Pages/Customer/CustomerList";
import { EditCustomer } from "../Pages/Customer/EditCustomer";
import { Dashboard } from "../Pages/Dashboard/Dashboard";
import { UserDashboard } from "../Pages/Dashboard/UserDashboard";
import Form from "../Pages/Form/Form";
import CreateEditFunctions from "../Pages/Functions/CreateEditFunctions";
import AuthCallback from "../Pages/Integration/AuthCallback";
import ExternalAuthorize from "../Pages/Integration/ExternalAuthorize";
import IntegrationTabs from "../Pages/Integration/IntegrationTabs";
import { Payment } from "../Pages/Payment/Payment";
import { PaymentHead } from "../Pages/Payment/PaymentHead";
import AddPhoneNumber from "../Pages/PhoneNumber/AddPhoneNumber";
import { PlanList } from "../Pages/Plan/PlanList";
import AddSubscriptionPlan from "../Pages/Plan/SubscriptionPlan/AddSubscriptionPlan";
import AddTopupPlan from "../Pages/Plan/TopupPlan/AddTopupPlan";
import AddPlanType from "../Pages/PlanType/AddPlanType";
import PlanTypeList from "../Pages/PlanType/PlanTypeList";
import { ChangePassword } from "../Pages/Profile/ChangePassword";
import { Profile } from "../Pages/Profile/Profile";
import { Reports } from "../Pages/Reports/Reports";
import Layout from "../Pages/Shared/Layout";
import PublicLayout from "../Pages/Shared/PublicLayout";
import Talk from "../Pages/Talk/Talk";
import { CustomerBilling } from "../Pages/TransactionHistory/CustomersBilling";
import { TransactionHistory } from "../Pages/TransactionHistory/TransactionHsitory";
import { AddUser } from "../Pages/User/AddUser";
import { EditUser } from "../Pages/User/EditUser";
import { UserList } from "../Pages/User/UserLIst";
import { addInterceptors } from "../Service/Interceptor";
import AssistantEditableFormSubmissionsList from "./../Pages/AssistantFormSubmissions/AssistantEditableFormSubmissionsList";

export default function AppRoutes() {
  const dispatch = useDispatch();

  // Add interceptors to the axiosInstance
  useEffect(() => {
    addInterceptors(dispatch); // Pass dispatch to the interceptor setup
  }, [dispatch]);

  const publicRoutes = [
    { path: "/billing", element: <Billing /> },
    { path: "/free-trial", element: <StartFreeTrial /> },
    { path: "/payment", element: <Payment /> },
    { path: "/talk/:id/:id", element: <Talk /> },
    { path: "/form/:id", element: <Form /> },
    { path: "/addPayment", element: <PaymentHead /> },
    { path: "/auth/callback/:provider", element: <AuthCallback /> },
    { path: "/authorize", element: <ExternalAuthorize /> },
    { path: "/authorize-n8n", element: <ExternalAuthorize /> },
  ];

  const authRoutes = [
    { path: "/", element: <SignIn /> },
    { path: "/signup", element: <SignUp /> },
    { path: "/forgotpassword", element: <ForgotPassword /> },
    { path: "/qr-scanner", element: <QRScanner /> },
    { path: "/otpverification", element: <OtpVerification /> },
    { path: "/resetPassword", element: <ResetPassword /> },
    { path: "/resetPassword/:id", element: <ResetPassword /> },
    // { path: "/card-details", element: <Stripe /> },
  ];

  const protectedRoutes = [
    { path: "/dashboard", element: <Dashboard /> },
    { path: "/subscription", element: <BillingComponent /> },
    { path: "/subscription-payment", element: <Payment /> },
    { path: "/topup-payment", element: <Payment isTopUpPlan /> },
    {
      path: "/additional-assistant-payment",
      element: <Payment isAdditionalAssistant />,
    },
    { path: "/users", element: <UserList /> },
    { path: "/add-user", element: <AddUser /> },
    { path: "/edit-user/:id", element: <EditUser /> },
    { path: "/customers", element: <CustomerList /> },
    { path: "/customerUser/:id", element: <UserList key="customerUser" /> },
    { path: "/add-customer", element: <AddCustomer /> },
    {
      path: "/edit-customer/:id",
      element: <EditCustomer key={"edit-customer/:id"} />,
    },
    { path: "/plans", element: <PlanList /> },
    { path: "/plan-types", element: <PlanTypeList /> },
    { path: "/add-plan-type", element: <AddPlanType /> },
    { path: "/edit-plan-type/:id", element: <AddPlanType isEdit /> },
    { path: "/add-subscription-plan", element: <AddSubscriptionPlan /> },
    { path: "/edit-subscription-plan/:id", element: <AddSubscriptionPlan /> },
    { path: "/add-topup-plan", element: <AddTopupPlan /> },
    { path: "/edit-topup-plan/:id", element: <AddTopupPlan /> },
    { path: "/meta-assistants", element: <AssitantsList /> },
    { path: "/add-meta-assistant", element: <AddAssistant /> },
    { path: "/assistants", element: <AssitantsList /> },
    { path: "/add-assistant", element: <AddAssistant /> },
    { path: "/add-assistant-builder", element: <AddAssistantBuilder /> },
    {
      path: "/add-assistant-builder/:customerId",
      element: <AddAssistantBuilder />,
    },
    { path: "/assistants/:customerId", element: <AssitantsList /> },
    { path: "/add-assistant/:customerId", element: <AddAssistant /> },
    { path: "/assistant/documents", element: <AssistantDocumentsList /> },
    {
      path: "/assistant/form-submissions",
      element: <AssistantEditableFormSubmissionsList />,
    },
    {
      path: "/assistant/form-submission/:id",
      element: <AssistantFormSubmissionDetail />,
    },
    { path: "/assistant/functions", element: <CreateEditFunctions /> },
    { path: "/assistant/knowledge-base", element: <CreateEditKnowledgeBase /> },
    // { path: "/addPayment", element: <PaymentHead /> },
    { path: "/profile", element: <Profile /> },
    { path: "/change-password", element: <ChangePassword /> },
    { path: "/customerbilling", element: <CustomerBilling /> },
    { path: "/transaction-history/:id", element: <TransactionHistory /> },
    { path: "/userdashboard", element: <UserDashboard /> },
    { path: "/reports", element: <Reports /> },
    { path: "/call-email-history", element: <CallEmailHistoryList /> },
    { path: "/chat", element: <Chat noSelectedChat /> },
    { path: "/meta-assistant-chat", element: <Chat noSelectedChat /> },
    {
      path: "/meta-assistant-chat/individual/:contactId/:assistantId",
      element: <Chat />,
    },
    { path: "/chat/individual/:contactId/:assistantId", element: <Chat /> },
    { path: "/chat/widget-chat/:widgetId/:assistantId", element: <Chat /> },
    { path: "/chat/individual-external/:id/:isEmail", element: <Chat /> },
    { path: "/chat/group/:groupId/:assistantId", element: <ChatGroups /> },
    {
      path: "/chat/group-chat/:groupId/:contactId/:assistantId",
      element: <Chat />,
    },
    { path: "/contacts", element: <ContactList /> },
    { path: "/integration", element: <IntegrationTabs /> },
    { path: "/phoneNumbers", element: <AddPhoneNumber /> },
    { path: "/call/:id", element: <ScheduleCall /> },
    { path: "/group-call/:id", element: <ScheduleCall /> },
    { path: "/email/:id", element: <ScheduleEmail /> },
    { path: "/group-email/:id", element: <ScheduleEmail /> },
    { path: "/group-members/:id", element: <ContactGroupUsersList /> },
    { path: "/add-contact", element: <AddContact /> },
    { path: "/add-group", element: <AddGroup /> },
    { path: "/edit-group/:id", element: <AddGroup /> },
    { path: "/edit-contact/:id", element: <EditContact /> },
    { path: "/view-assistants", element: <ViewAssistants /> },
  ];

  return (
    <Router>
      <Suspense>
        <Routes>
          {/* Public Routes */}
          {authRoutes.map((route) => (
            <Route key={"authRoutes"} element={<PublicLayout />}>
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            </Route>
          ))}
          {publicRoutes.map((route) => (
            <Route key={"publicRoutes"}>
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            </Route>
          ))}

          {/* Protected Routes */}
          {/* {cannotAccessRoute() ? ( */}
          <Route key={"protectedRoutes"} element={<Layout />}>
            {protectedRoutes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={route.element}
              />
            ))}
          </Route>
          {/* ) */}
          {/* : (
            <Route key="/"  path="*" element={<Login />} />
          )} */}
        </Routes>
      </Suspense>
    </Router>
  );
}
